import styled from "styled-components";
import { COLORS } from "../../../shared/consts";
import { toRem } from "shared/helpers";

export const Card = styled.div`
  background: ${COLORS.BG.SURFACE2};
  color: ${COLORS.FG.DEFAULT};
  border-radius: ${toRem(16)};
  padding: ${toRem(24)};

  @media (max-width: 768px) {
    background-color: transparent;
    padding: 0;
  }
`;

export const MonthsRow = styled.div`
  display: flex;
  gap: ${toRem(8)};
  padding-bottom: ${toRem(16)};
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-wrap: nowrap;
    padding-bottom: ${toRem(8)};
    overflow-x: auto;
    scroll-snap-type: x mandatory;

    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }

  @media (max-width: 768px) ::-webkit-scrollbar {
    display: none;
  }
`;

export const Weekdays = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  font-size: ${toRem(14)};
  font-weight: 500;
  line-height: ${toRem(20)};
  color: ${COLORS.FG.SOFT};
  text-transform: lowercase;

  span {
    text-align: right;
    padding: ${toRem(8)} ${toRem(16)};
  }

  span:nth-child(6),
  span:nth-child(7) {
    color: ${COLORS.ACCENT.DEFAULT};
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const Divider = styled.div`
  height: 1px;
  background: ${COLORS.BORDER.MUTED};
  margin: 2px 0 0px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  column-gap: 0;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const DayCell = styled.div<{ dim?: boolean; cursor?: boolean }>`
  min-height:${toRem(64)};
  display: grid;
  grid-template-rows: auto auto auto;
  align-content: start;
  padding: ${toRem(16)};
  gap: ${toRem(6)};
  border-bottom: ${toRem(1)} solid ${COLORS.BORDER.MUTED};
  border-right: ${toRem(1)} solid ${COLORS.BORDER.MUTED};
  color: ${(p) => (p.dim ? COLORS.FG.DISABLED : COLORS.FG.SOFT)};
  opacity: ${(p) => (p.dim ? 0.4 : 1)};
  cursor: ${(p) => (p.cursor ? "pointer" : "default")};
`;

export const DayHeader = styled.div<{ weekend?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${toRem(6)};
  font-size: ${toRem(14)};
  font-weight: 700;
  line-height: ${toRem(20)};
  color: ${({ weekend }) =>
    weekend ? COLORS.ACCENT.DEFAULT : COLORS.FG.DEFAULT};
`;

export const DayHeaderDay = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3px 4px 1px;
  border-radius: 4px;
  font-size: ${toRem(14)};
  font-weight: 700;
  line-height: ${toRem(20)};
  color: ${COLORS.FG.DEFAULT};
  background-color: ${COLORS.ACCENT.DEFAULT};
`;

export const IconRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${toRem(8)};

  svg {
    width: ${toRem(32)};
    height: ${toRem(32)};
  }
`;

export const TempColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${toRem(4)};
`;

export const TempMain = styled.span`
  color: ${COLORS.FG.DEFAULT};
  font-size: ${toRem(16)};
  font-weight: 600;
`;

export const TempFeels = styled.span`
  font-size: ${toRem(12)};
  color: ${COLORS.FG.SOFT};
`;
